<!--  -->
<template>
  <div class="training-area-wrap">
    <hardware-block-editor
      :class="['blockly-editer', { 'blockly-editer-open': !sidebarSwitch }]"
      :workspaceIsVisible="workspaceIsVisible"
      v-model="Blocks"
      :project-id="projectId"
      :trainingId="trainingId"
      :xml-data="{
        name: Project.ProjectName,
        type: 1,
        path: Project.BlocksFileUrl,
      }"
      :save-flag="saveFlag"
      v-bind="$attrs"
      v-on="$listeners"
      ref="blockly"
      @getMedia="getMedia"
      :Media.sync="Media"
    >
      <!-- :Media.sync="Media" -->
      <!-- 基础积木 -->
      <!-- 自定义的预加载模块，需要事先添加相应的 gta_ai_event.js  -->
      <category name="%{BKY_CATEVENT}" colour="50">
        <block type="gta_define_robot"></block>
        <block type="gta_turn_on_motion"></block>
        <block type="gta_turn_off_motion"></block>
        <!-- <block type="gta_ai_event_1"></block> -->
        <block type="gta_ai_event_2"></block>
        <block type="gta_ai_event_print">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_ai_event_3"></block>
        <block type="gta_ai_event_4"></block>
        <block type="gta_ai_event_5"></block>
         <block type="gta_ai_event_6">
            <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
         </block>
      </category>

      <!-- 控制 -->
      <category name="%{BKY_CATLOOPS}" colour="%{BKY_LOOPS_HUE}">
        <!-- <block type="logic_null"></block> -->
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <shadow type="math_number">
              <field name="NUM">20</field>
            </shadow>
          </value>
        </block>

        <block type="gta_controls_whileUntil">
          <value name="NAME1">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <!-- <block type="controls_whileUntil"></block> -->

        <block type="controls_for">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
          <value name="BY">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <block type="controls_forEach">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="break_continue"></block>
        <!-- <block type="controls_flow_statements"></block> -->

        <!-- 逻辑  start-->
        <block type="controls_if">
          <value name="IF0">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <block type="logic_negate">
          <value name="BOOL">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- <block type="logic_boolean"></block> -->
        <!-- 三元表达式 -->
        <block type="logic_ternary">
          <value name="IF">
            <shadow type="logic_null"></shadow>
          </value>
          <value name="THEN">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
          <value name="ELSE">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
        </block>
        <block type="waiting_time"></block>
        <!-- 时间积木-->
        <!-- 逻辑  end-->
      </category>
      <!-- math 运算 -->
      <category name="%{BKY_CATMATH}" colour="%{BKY_MATH_HUE}">
        <!-- <block type="gta_ai_add_1" ></block> -->
        <!-- 数字 -->
        <!-- <block type="math_change"></block> -->
        <block type="math_number">
          <field name="NUM">123</field>
        </block>

        <!-- 加法 -->
        <block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <!-- 比较> = <  -->
        <block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- 真/假 成立/不成立 -->
        <block type="logic_boolean"></block>

        <!-- 1~100随机数 -->
        <block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 取余-->
        <block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>
        <!-- 绝对值、平方根、对数、log ln 指数的运算 -->
        <block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <!-- sin/cos 等三角函数 -->
        <block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>

        <!-- π、e等重要常量 -->
        <block type="math_constant"></block>
        <!-- 奇数或者偶数  -->
        <block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>
        <!-- 四舍五入 -->
        <block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>
        <!-- 随机数 -->
        <block type="math_random_float"></block>
        <block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 将50限制在1-100之间 -->
        <block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 方位角 -->
        <block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
      </category>

      <!-- 文本  name="%{BKY_CATDATATYPE}"-->
      <category name="%{BKY_CATTEXT}" colour="%{BKY_DATATYPE_HUE}" v-if="false">
        <!-- 新建文本 -->
        <block type="text"></block>
        <!-- 尾部增加文本内容 -->
        <block type="text_join"></block>

        <!-- 。。。的长度length -->
        <block type="text_length">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <!-- 。。。变量类型(文本类型)的切换 -->
        <block type="gta_ai_variable_change"></block>
        <block type="gta_ai_variable_change_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <!-- 转为小写/大写 -->
        <block type="text_changeCase">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>

        <!-- 某字符是否存在于字符串（文本）的判断 -->
        <block type="gta_ai_text_include"></block>
        <block type="gta_ai_text_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT">Hello</field>
            </shadow>
          </value>
          <value name="NAME2">
            <shadow type="text">
              <field name="TEXT">Hello</field>
            </shadow>
          </value>
        </block>
        <!-- 文本是否为空的判断 -->
        <block type="text_isEmpty">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <block type="text_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="FIND">
            <shadow type="text">
              <field name="TEXT">abcd</field>
            </shadow>
          </value>
        </block>

        <!-- 将文本分割为列表 -->
        <block type="lists_split">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>
        <!-- 将列表分拼接为文本 -->
        <block type="lists_split_1">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>
        <!-- <block type="text_charAt">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">{textVariable}</field>
              </block>
            </value>
          </block>
          -->
        <!-- 取得文本子字符 -->
        <block type="text_getSubstring">
          <value name="STRING">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="AT1">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="AT2">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>
        <!-- 追加文本 -->
        <block type="text_append">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_trim">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <!--
  要求输入文本并提示信息功能处理不了
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          -->
      </category>

      <!--列表-->
      <category
        name="%{BKY_CATLISTS}"
        colour="%{BKY_DATATYPE_HUE}"
        v-if="false"
      >
        <!-- 新建列表 -->
        <block type="lists_create_with">
          <mutation items="0"></mutation>
        </block>
        <!-- 列表补充功能 -->
        <block type="lists_create_with">
          <mutation items="2"></mutation>
        </block>

        <!-- 设置列表第n项索引的值，或在第n项中插入值 -->
        <block type="lists_setIndex">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_getIndex">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_length">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_getSublist">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_isEmpty">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_repeat">
          <value name="ITEM">
            <block type="text"></block>
          </value>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">5</field>
            </shadow>
          </value>
        </block>
        <block type="gta_ai_lists_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="gta_ai_lists_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_sort"></block>
      </category>

      <!-- 字典 -->
      <category name="%{BKY_CATDICT}" colour="%{BKY_DATATYPE_HUE}" v-if="false">
        <block type="create_dict"></block>
        <block type="dict_create_with">
          <mutation items="1"></mutation>
        </block>
        <block type="set_dict"></block>
        <block type="gta_ai_get_dict_key"></block>
        <block type="length_of_dict"></block>
        <block type="del_dict_key"></block>
        <block type="del_dict_key_2">
          <value name="key">
            <block type="text">
              <field name="TEXT"></field>
            </block>
          </value>
        </block>
        <block type="gta_ai_dict_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>
        <block type="gta_ai_dict_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>
      </category>

      <!-- 变量 -->
      <category
        name="%{BKY_CATVARIABLES}"
        colour="%{BKY_VARIABLES_HUE}"
        custom="VARIABLE"
      ></category>

      <!-- 函数 -->
      <category
        name="%{BKY_CATFUNCTIONS}"
        colour="%{BKY_PROCEDURES_HUE}"
        custom="PROCEDURE"
        class="PROCEDURE"
      ></category>

      <category name="媒体" custom="upload_pic">
       
      </category>

      <category name="行驶" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_move_in_open_loop"></block>
        <block type="gta_straight_move"></block>
        <block type="gta_robot_turn"></block>
      </category>
      <category name="灯光" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_set_light_color"></block>
        <block type="gta_set_light_mode_on"></block>
        <block type="gta_set_light_mode_blink"></block>
        <block type="gta_set_light_mode_breathe"></block>
        <block type="gta_light_on_of"></block>
      </category>

      <category name="姿势" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_forearm_move_in_open_loop"></block>
        <block type="gta_forearm_move"></block>
        <block type="gta_arm_move_in_open_loop"></block>
        <block type="gta_arm_move"></block>
        <block type="gta_head_move_in_open_loop"></block>
        <block type="gta_head_move"></block>
        <block type="gta_paw_move_in_open_loop"></block>
        <block type="gta_paw_move"></block>
      </category>

      <category name="声音" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_tts"></block>
        <block type="gta_robot_play"></block>
        <block type="gta_get_play_status"></block>
        <block type="gta_set_volume"></block>
        <block type="gta_get_volume"></block>
      </category>

      <category name="情感" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_play_emotion_1"></block>
        <block type="gta_robot_play_emotion_2"></block>
        <block type="gta_robot_play_emotion_3"></block>
        <block type="gta_robot_play_emotion_4"></block>
        <block type="gta_robot_play_emotion_5"></block>
        <block type="gta_robot_play_emotion_6"></block>
        <block type="gta_turn_on_expression"></block>
        <block type="gta_turn_off_expression"></block>
      </category>

      <category name="显示" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_display_image">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_robot_display_audio">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_robot_show_camera"></block>
        <block type="gta_robot_stop_showing"></block>
      </category>

      <!-- 果力机器人 -->
      <category name="检测" colour="%{BKY_VARIABLES_HUE}">
        <block type="gta_turn_on_cliff_detection"></block>
        <block type="gta_turn_off_cliff_detection"></block>
        <block type="gta_robot_read_infrared"></block>
        <block type="gta_detect_face"></block>
        <block type="gta_get_face_feature"></block>
        <block type="gta_detect_pattern"></block>
        <block type="gta_get_pattern_location"></block>
        <block type="gta_read_gyroscope"></block>
        <block type="gta_read_gyroscope2"></block>
      </category>

      <category name="摄像头" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_display_video"></block>
        <block type="gta_robot_get_camera_image"></block>
      </category>

      <sep></sep>
    </hardware-block-editor>
  </div>
</template>

<script>
import HardwareBlockEditor from '@/components/hardwareBlockEditor/HardwareBlockEditor.vue'
import bus from '@/utils/bus'
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
import { mapGetters } from 'vuex'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'HardwareBlockIndex',
  components: { HardwareBlockEditor },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 项目ID
    projectId: {
      type: String,
      default: null,
    },
    // xml 保存相关数据
    xmlData: {
      type: Object,
      default: () => {
        return {
          str: '',
          name: '',
          type: 1,
          path: '',
        }
      },
    },
    // 保存指令 flag，保存指令传达，prevSaveWorkSpaceXmlTxt 将会保存一次，用来比较是否有所改变
    saveFlag: {
      type: Number,
      default: 0,
    },
    // 语言信息
    langMsg: {
      type: Object,
      default: () => {
        // return BlocklLangMsg.en;
      },
    },
    // 颜色主题
    theme: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 渲染器
    renderer: {
      type: String,
      default: 'gta',
    },
    // 自定义模块添加
    blocks: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // stepOperate: {
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {
      workspaceIsVisible: true,
      sidebarSwitch: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      hasAttr: false,
      scoreTitle: '实训评分',
      Media: [],
      mediaGotten: 0,
      trainingDetails: { status: 2 }, // 需要从接口获取
      reportInfo: {}, //实训报告信息
      guideBookSwitch: {
        type: 'guideBook',
        sidebarSwitch: true,
      },
      codeRunSwitch: {
        type: 'codeRun',
        sidebarSwitch: true,
      },
      buildingBlocksType: 0, //保存的积木类型：1项目题解，2项目题面，3基础模型，4提交作业
      Project: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: 'AI 人形机器人',
        BlocksFileUrl: '',
      },
      projectTask: {
        trainingName: '', // 实训名称
        points: '', // 技能点
        presetGoal: '', // 预设目标
        selfRatedScore: '', // 学生自评分数
        score: '', // 老师评分
        appraise: '', // 老师评语
      },
      NewProject: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: '新建项目',
        BlocksFileUrl: '',
      },
      MyProjectList: {
        PageSize: 10000, // TODO:暂全部显示
        Items: [],
      },
      Cases: [],
      taskInfo: null, // 作业任务信息;
      submitObj: {
        //学生提交字段
        ProjectId: '', //项目id
        ProjectName: '', //项目名称
        ProjectContent: '', // 项目描述 ,
        points: '', //技能点
        presetGoal: '', //预设目标
        selfRatedScore: '', //自评分数;
      },
      buildingBlocksTypeObj: {
        //积木类型
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      popupActive: '',
      searchKey: '',
      Blocks: { TotalCount: 0, Items: [] },
      isComplete: 1, //1完成，0未完成
      isPublic: 1, //1完成，0未完成
      TrainId: '',
      CourseHourId: null,
      CourseName: null,
      leaveType: '', //跳转的路由来源
      Status: null,
      scored: null, //判断是否已评分状态进来
      score: null, //具体分数
      // codeText: "", //运行结果，在runCode组件中处理;
      rightSideVal: 'guideBook',
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
    } //data end
  },
  computed: {
    ...mapGetters([
      'accountInfo',
      'studentId',
      'hasRunSuccess',
      'Train',
      'curriculumId',
      'userRole',
    ]),
    status() {
      let Train = this.Train
      return Train.status
    },
  },
  watch: {},

  created() {
    let self = this
  },
  mounted() {
    let self = this
    this.popupActive = ''
    //监听 转换 代码模式/积木模式
    bus.$on('changeMode', () => {
      self.changeMode()
    })

    // 监听调用重绘
    bus.$on('onSidebarSwitch', (switchObj) => {
      self.sidebarSwitchHandle(switchObj)
    })
  },
  methods: {
    /**
     *
     *
     *
     * 运行功能处理模块
     */
    // runHandle() {
    //   // let codeText = this.$refs.blockly.runHandle();/
    //   // this.$store.state.blocklyHome.codeText = codeText; //原始的积木文本
    //   // this.codeText = codeText;
    //   // return codeText;
    // },
    changeMode() {
      var btnToCode = document.getElementById('btnCodeEditer')
      this.workspaceIsVisible = !this.workspaceIsVisible
      bus.$emit('getWorkspaceIsVisible', this.workspaceIsVisible)
      // 触发内部转换代码按钮
      if (!this.workspaceIsVisible) {
        btnToCode.click()
      }
    },
    getMedia(pageIndex) {
      let { trainingId, accountInfo, projectId } = this,
        data = {}
      //实训中心里根据trainingId获取媒体积木
      if (trainingId) {
        data = {
          trainingId,
          userId: accountInfo.userId,
        }
        return BLOCK.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      } else if (projectId) {
        //ai-T编辑器里根据trainingId获取媒体积木
        data = {
          projectId,
        }

        return AI_EDITOR.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      }
    },
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      // this.sidebarSwitch = sidebarSwitch;
      this.sidebarSwitch = switchObj.sidebarSwitch
      if (window) {
        this.$nextTick(() => {
          // window.dispatchEvent(new Event("resize"));
          var resizeEvent = window.document.createEvent('UIEvents')
          resizeEvent.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(resizeEvent)
        })
      }
    },
    // 重命名
    // saveCopyProject() {},
    // 项目案例
    // caseToWorkspace(idx) {
    //   var ProjectCase = this.Cases[idx],
    //     ProjectName = ProjectCase.CaseName,
    //     xmlText = ProjectCase.xmlText;

    //   // 创建一个新的 Project
    //   // TODO:利用项目 ID 全置 0 来做项目案例前期标记
    //   this.Project.ProjectId = this.Placeholder.ProjectId;
    //   this.Project.ProjectName = ProjectName;
    //   this.Project.BlocksFileUrl = null;

    //   // 保存时候会用到
    //   this.NewProject.ProjectName = ProjectName;

    //   // 打开 XML
    //   this.$refs.blockly.createBlocksByWorkspaceXML(xmlText, true);
    //   this.$refs.blockly.workspace.clear();
    //   this.$refs.blockly.textToWorkspace(xmlText);

    //   // 关闭弹窗
    //   this.cancelPopup();
    // },
  }, //methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {
    bus.$off('changeMode')
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/practical_training_blockly_editer.scss';
.on {
  display: inline-block;
}

.off {
  display: none;
}
</style>
